import { useEffect, useState } from "react";
import { Download, FileText, Image as ImageIcon, Trash2, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { fmtBytes, fmtDateTime } from "@/lib/format";

const useBlob = (id) => {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    let href;
    setUrl(null);
    setErr(false);
    api.get(`/attachments/${id}/file`, { responseType: "blob" })
      .then((r) => { href = URL.createObjectURL(r.data); setUrl(href); })
      .catch(() => setErr(true));
    return () => { if (href) URL.revokeObjectURL(href); };
  }, [id]);
  return { url, err };
};

export default function AttachmentPreview({ att, index, onRemove }) {
  const { url, err } = useBlob(att.id);
  const isPdf = att.content_type === "application/pdf";
  const removed = att.status === "removed";
  return (
    <div className={`border rounded-md overflow-hidden ${removed ? "border-red-200 opacity-60" : "border-slate-200"}`} data-testid={`attachment-item-${index}`}>
      <div className="flex items-center gap-2 px-3 py-2 bg-slate-50 border-b border-slate-200">
        {isPdf ? <FileText className="w-4 h-4 text-red-600" /> : <ImageIcon className="w-4 h-4 text-sky-600" />}
        <div className="flex-1 min-w-0">
          <div className="text-sm truncate">{att.file_name}</div>
          <div className="text-[11px] text-slate-400 num">{fmtBytes(att.size)} · {att.uploaded_by_name} · {fmtDateTime(att.uploaded_at)}</div>
        </div>
        {url && <a href={url} download={att.file_name}><Button size="sm" variant="ghost" data-testid={`attachment-download-${index}`}><Download className="w-4 h-4" /></Button></a>}
        {onRemove && !removed && <Button size="sm" variant="ghost" className="text-red-600" onClick={() => onRemove(att)} data-testid={`attachment-remove-${index}`}><Trash2 className="w-4 h-4" /></Button>}
      </div>
      {removed ? (
        <div className="px-3 py-3 text-xs text-red-700">Removed by {att.removed_by_name}: {att.removed_reason}</div>
      ) : err ? (
        <div className="px-3 py-6 text-xs text-orange-700 text-center">File unavailable in storage</div>
      ) : !url ? (
        <div className="py-10 flex justify-center"><Loader2 className="w-5 h-5 animate-spin text-slate-400" /></div>
      ) : isPdf ? (
        <iframe src={url} title={att.file_name} className="w-full h-[480px] bg-white" />
      ) : (
        <a href={url} target="_blank" rel="noreferrer"><img src={url} alt={att.file_name} className="w-full max-h-[480px] object-contain bg-slate-100" /></a>
      )}
    </div>
  );
}
